module.exports = __webpack_public_path__ + "static/img/059.2b9c740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/059.png
// module id = kBIP
// module chunks = 0